import { FunctionComponent } from "react";
import { graphql } from "@apollo/client/react/hoc";

import {
    MEMES_QUERY,
    CREATE_MEME_MUTATION,
    UPDATE_MEME,
    DELETE_MEME_MUTATION,
} from "../graphql";
import { captureException } from "@sentry/react";

// Query
export const withMemes = (Component: FunctionComponent) =>
    graphql(MEMES_QUERY, {
        options: ({ where, pagination }) => {
            return {
                variables: {
                    where,
                    ...pagination,
                },
            };
        },
        props: ({ data }) => {
            const {
                loading,
                error,
                memes,
                fetchMore,
                subscribeToMore,
                updateQuery,
                refetch,
            } = data;
            const loadQuestionsData = (offset: number) => {
                return fetchMore({
                    variables: {
                        offset,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            memes: [
                                ...previousResult.memes,
                                ...fetchMoreResult.memes,
                            ],
                        };
                    },
                });
            };
            if (error) throw new Error(error.message);
            return {
                loading,
                memes,
                subscribeToMore,
                updateQuery,
                loadQuestionsData,
                refetchMemes: refetch,
            };
        },
    })(Component);

// Mutation
export const withCreateMeme = (Component: FunctionComponent) =>
    graphql(CREATE_MEME_MUTATION, {
        props: ({ mutate }) => ({
            createMeme: async (object: Object) => {
                // console.log(
                //     "🚀 ~ file: Operations.ts ~ line 60 ~ createMeme: ~ object",
                //     object,
                // );
                try {
                    const {
                        data: { insert_meme_one },
                    } = await mutate({
                        variables: { object },
                        optimisticResponse: {
                            __typename: "Mutation",
                            createMeme: {
                                object,
                                __typename: "INSERT_MEME_ONE",
                            },
                        },
                    });
                    return insert_meme_one;
                } catch (e) {
                    captureException(e)
                    console.error(e);
                }
            },
        }),
    })(Component);

export const withUpdateMeme = (Component: FunctionComponent) =>
    graphql(UPDATE_MEME, {
        props: ({ mutate }) => ({
            updateMeme: (object: Object) => {
                mutate({
                    variables: { ...object },
                    optimisticResponse: {
                        updateMeme: {
                            ...object,
                            __typename: "meme",
                        },
                    },
                });
            },
        }),
    })(Component);

export const withDeleteMeme = (Component: FunctionComponent) =>
    graphql(DELETE_MEME_MUTATION, {
        props: ({ mutate }) => ({
            deleteMeme: (id: string) => {
                mutate({
                    variables: { id },
                    optimisticResponse: {
                        __typename: "Mutation",
                        deleteMeme: {
                            id,
                            __typename: "DELETE_MEME_BY_PK",
                        },
                    },
                });
            },
        }),
    })(Component);
